import { SCI_PALETTE } from "@/lib/science/sci-chart";
import { PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const EXAMPLE = "Chrome,63\nSafari,20\nEdge,5\nFirefox,3\nOther,9";

export function PiePlot({ donut = false }: { donut?: boolean }) {
  return (
    <PlotShell
      toolId={donut ? "donut-chart" : "pie-chart"}
      inputLabel={m.plot_input_label()}
      placeholder={m.pie_placeholder()}
      example={EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => ({
        tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
        legend: { bottom: 0, textStyle: { color: theme.muted } },
        color: SCI_PALETTE,
        series: [
          {
            type: "pie",
            radius: donut ? ["45%", "72%"] : "72%",
            center: ["50%", "46%"],
            data: data.rowLabels.map((name, i) => ({
              name,
              value: Number.isFinite(data.matrix[i]?.[0])
                ? data.matrix[i][0]
                : 0,
            })),
            label: { color: theme.text },
            labelLine: { lineStyle: { color: theme.border } },
            itemStyle: { borderColor: "transparent", borderWidth: 1 },
          },
        ],
      })}
    />
  );
}
